import { styles } from "./styles";
import { InfoCircleTwoTone } from "@ant-design/icons";
import HighlightText from "@shared/typo/HighlightText";
import { Tooltip } from "antd";
import React from "react";

type Props = {
  context: string | null;
  search: string;
};

const TranslationTableContext = (props: Props): JSX.Element => (
  <Tooltip
    className={styles.tooltipWrapper}
    title={
      props.context ? (
        <HighlightText text={props.context} search={props.search} />
      ) : (
        " "
      )
    }
  >
    <InfoCircleTwoTone className={styles.tooltipWrapper} />
  </Tooltip>
);

export default TranslationTableContext;
